import { useCallback, useState } from 'react';
import noop from 'lodash/noop';
export default function useCheckedProp(props) {
  const controlled = Reflect.has(props, 'checked');
  const {
    checked: _checked,
    onChange,
    disabled,
    defaultChecked
  } = props;
  const [checked, setChecked] = useState(defaultChecked != null ? defaultChecked : false);
  const handleChange = useCallback(e => {
    if (!controlled) setChecked(e.target.checked);
    onChange == null ? void 0 : onChange(e);
  }, [onChange, controlled]);
  return {
    onChange: disabled ? noop : handleChange,
    checked: controlled ? _checked : checked
  };
}